import React from "react";
import { useParams } from "react-router-dom";
import TopDeals from "./TopDeals";

function TopDealForm(props) {
  const { id } = useParams();

  const mode = id ? "edit" : "create";

  return <TopDeals {...props} mode={mode} dealId={id} />;
}

export default TopDealForm;
